"use client";

import React, { createContext } from "react";

export type CurrentUserType =
  | "member"
  | "employer"
  | "health_insurance_society_staff";

const CurrentUserTypeContext = createContext<{
  type: CurrentUserType | undefined;
}>({
  type: undefined,
});

export const CurrentUserTypeContextProvider = ({
  children,
  type,
}: {
  children: React.ReactNode;
  type: CurrentUserType;
}) => (
  <CurrentUserTypeContext.Provider value={{ type }}>
    {children}
  </CurrentUserTypeContext.Provider>
);

export const useCurrentUserType = () =>
  React.useContext(CurrentUserTypeContext);
